import React from 'react';
import useIGTranslation from '../../hooks/useIGTranslation';

import './HowItWorks.scss';
import { TFunction } from 'i18next';

export interface HowItWorksProps {
  translationKeys: Array<string>;
}

interface GetTranslationKeyProps {
  key: string;
  index: number;
  t: TFunction;
}

const getTranslationKey = ({ key, index, t }: GetTranslationKeyProps) => {
  if (index !== 1 || process.env.REACT_APP_LANGUAGE === 'nl') return t(key);

  switch (process.env.REACT_APP_REGION) {
    case 'uk':
      return t(key, { value: '£50' });
    case 'ng':
      return t(key, { value: '₦2000' });
    case 'ie':
      return t(key, { value: '€50' });
    case 'bg':
      return t(key, { value: '50 лв.' });
  }
};

const HowItWorks = ({ translationKeys }: HowItWorksProps) => {
  const { t } = useIGTranslation();
  return (
    <div className="how-it-works">
      <div className="how-it-works__title">{t('how-it-works-title')}</div>
      {translationKeys.map((key, index) => (
        <div key={index} className="how-it-works__text">
          <div className="how-it-works__number">{t(`how-it-works-number-${index + 1}`)}</div>
          {getTranslationKey({ key, index, t })}
        </div>
      ))}
    </div>
  );
};

export default HowItWorks;
